
import crypto from 'crypto';

const unmaskinData = (id, date, isPageUpdate) => {
  if (!isPageUpdate) {
    return null; 
  }

  const key = process.env.VUE_APP_UNMASKING_KEY;
  const versionAtob = atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3));

  const versionUnmask = Buffer.from(
    crypto.createHash('sha256') 
      .update(id.toString() + date + versionAtob) 
      .digest('hex')
  ).toString('base64');

  const signatureValue = crypto.createHmac('sha256', key)
    .update(versionUnmask)
    .digest('base64');

  return {
    'X-View-Signature': signatureValue,
  };
  
};
export default unmaskinData;
